/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Login_Discord_LoginInputs */



/**
* | output |
* | --- |
* | "Continue with Discord" |
*
* @param {Login_Discord_LoginInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const login_discord_login = /** @type {((inputs?: Login_Discord_LoginInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Login_Discord_LoginInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Continuer avec Discord")
	if (locale === "es") return /** @type {LocalizedString} */ ("Continuar con Discord")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Continuar com Discord")
	if (locale === "it") return /** @type {LocalizedString} */ ("Continua con Discord")
	return /** @type {LocalizedString} */ ("Continue with Discord")
});